import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { RecorderService } from '../_services/recorder.service';

export const recordingGuard: CanDeactivateFn<unknown> = () => {
  return inject(RecorderService).handleDeactivation();
};
